const IsFirefoxUser = () => {
  const ua = navigator.userAgent.toLowerCase();
  return ua.includes("firefox") || ua.includes("fxios");
};

export {IsFirefoxUser};